import React from 'react';
import { useAppDispatch,useAppSelector } from '../../../app/hooks';
import {
    deleteAccountShiftAsync, getAccountShiftByAccountShiftIdAsync, checkedState, unCheckedState,
    checkedAllState, unCheckedAllState, UpdateIsDisabledRecordAsync,updateSorting
} from '../shift/ShiftSlice';
import { Dropdown } from 'react-bootstrap'
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import clsx from 'clsx';
import {  formatDateToTime } from '../../../common/timeLiveFunction';
import '../../../common/css/timeLive.css'
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';
import { format12HoursOnly } from '../../../common/UiUtilities';

const itemClass = 'ms-1 ms-lg-0';
const ShiftItem = (props: any) => {
    const { shiftList, t, IsEdit, IsDelete } = props;
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.shift);
    const dispatch = useAppDispatch();

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onEditClick = (AccountShiftId: number) => {
        dispatch(getAccountShiftByAccountShiftIdAsync(AccountShiftId));
    }

    const onDeleteClick = (AccountShiftId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountShiftAsync(AccountShiftId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Shift deleted Successfully", 'Success', "success", "toast-top-right") :
                                originalPromiseResult.StatusCode === "409" ?
                                    ShowToast(originalPromiseResult.ResponseMessage, 'Warning', "warning", "toast-top-right") :
                                    ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");

                        })
                        .catch((rejectedValueOrSerializedError) => {

                        })
                }
            })
            .catch((error) => {
            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, AccountShift: any) => {
        const { checked } = e.target;
        const foundIndex = shiftList.findIndex((item: any) => item.AccountShiftId === AccountShift.AccountShiftId);
        if (foundIndex !== -1) {
            const foundItem = shiftList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...shiftList.slice(0, foundIndex), updatedItem, ...shiftList.slice(foundIndex + 1)];
            dispatch(UpdateIsDisabledRecordAsync(updatedItem));
        }
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                  
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={shiftList.every((item: any) => item.isSelected === 0) ? false :
                                            (shiftList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                       <th style={{ width: '15%' }}>
                        {/* {t('Active / Inactive')} */}
                        {getValueFromResource('Active / Inactive',dispatch, t)}

                        {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Shift Name')} */}
                            {getValueFromResource('Shift Name',dispatch, t)}

                        {sortColumn === 'Name' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Name") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Name") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Name") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Name") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Shift Code')} */}
                            {getValueFromResource('Shift Code',dispatch, t)}

                        {sortColumn === 'Code' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Code") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Code") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Code") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Code") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Start Time')} */}
                            {getValueFromResource('Start Time',dispatch, t)}

                        {sortColumn === 'StartTime' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "StartTime") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "StartTime") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "StartTime") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "StartTime") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('End Time')} */}
                            {getValueFromResource('End Time',dispatch, t)}
                        {sortColumn === 'EndTime' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "EndTime") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "EndTime") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "EndTime") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "EndTime") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* {IsEdit &&
                            <th className='col'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='col text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {shiftList.length === 0 && <tr><td colSpan={7}><p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}

                        </p></td></tr>}
                    {shiftList.length > 0 && shiftList.map((ShiftDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check "
                                            checked={ShiftDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, ShiftDetail.AccountShiftId) }}
                                        />
                                    </div>
                                </td>
                            }
                            <td>
                                {/* <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(ShiftDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                    {ShiftDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                </span> */}
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(ShiftDetail.IsDisabled === false ? "Active" : "InActive"))}>
                                    {ShiftDetail.IsDisabled === false ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td id={`${IsEdit ? 'kt_OffCanvas' : ''}`} className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(ShiftDetail.AccountShiftId) : undefined}
                            >
                                <span className="d-block">
                                    {ShiftDetail.Name}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {ShiftDetail.Code}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {/* {formatDateToTime(ShiftDetail.StartTime)} */}
                                    {format12HoursOnly(ShiftDetail.StartTime, 0)}
                                    {/* {new Date(ShiftDetail.StartTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })} */}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {/* {new Date(ShiftDetail.EndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })} */}
                                    {/* {formatDateToTime(ShiftDetail.EndTime)} */}
                                    {format12HoursOnly(ShiftDetail.EndTime, 0)}
                                </span>
                            </td>
                            {/* {IsEdit &&
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px "
                                            id="IsDisabled"
                                            checked={ShiftDetail.IsDisabled === 'Yes' ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, ShiftDetail) }}
                                        /> 
                                        
                                    </div>
                                </td>
                            } */}
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}

                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            id="kt_OffCanvas"
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => onEditClick(ShiftDetail.AccountShiftId)}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit')}`} */}
                                                                {getValueFromResource('Edit',dispatch, t)}

                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                            {IsDelete && IsEdit &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }
                                            {IsDelete &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(ShiftDetail.AccountShiftId) }}>
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                {/* {`${t('Delete')}`} */}
                                                                {getValueFromResource('Delete',dispatch, t)}

                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}
export default ShiftItem